import { createFileRoute } from "@tanstack/react-router";

import { type ChildRouteContext } from "@/root";
import {
  redirectIfModuleDisabled,
  throwIfHasNoPermission,
} from "@/utils/permissions";

import ProfileSettingsForm from "../../../components/settings/ProfileSettingsForm";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/profile",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("profile", context.tenant.modules);

    throwIfHasNoPermission(context.user, "profile.profile-settings.view");

    return {} satisfies ChildRouteContext;
  },
});

function RouteComponent() {
  return <ProfileSettingsForm />;
}
